export default __webpack_public_path__ + "static/media/our-team-member-04.3decb5df.jpg";